/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const dateMinutesAgo = (minutesAgo: number) => {
  const date = new Date();
  return new Date(date).setMinutes(date.getMinutes() - minutesAgo);
};

export const dateSecondsAgo = (secondsAgo: number) => {
  const date = new Date();
  return new Date(date).setSeconds(date.getSeconds() - secondsAgo);
};
